import { render, staticRenderFns } from "./menu.view.vue?vue&type=template&id=ad1e8b72&scoped=true"
import script from "./menu.view.vue?vue&type=script&lang=js"
export * from "./menu.view.vue?vue&type=script&lang=js"
import style0 from "./menu.view.vue?vue&type=style&index=0&id=ad1e8b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1e8b72",
  null
  
)

export default component.exports